/** 로그인·새로고침 직후 Todo LS↔서버 revision head 비교를 한 번만 돌리기 위한 플래그 */

let pendingLoginHeadSync = false;

export function markTodoNoteLoginHeadSyncPending(): void {
  pendingLoginHeadSync = true;
}

export function consumeTodoNoteLoginHeadSyncPending(): boolean {
  if (!pendingLoginHeadSync) return false;
  pendingLoginHeadSync = false;
  return true;
}
